import {Button, Form, Input, Modal, Switch, DatePicker} from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import notificationService from '../../services/notification-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import UploadImage from '../../components/upload/image';
import EditableTagGroup from '../../components/input/editable-tag-group';
import { fileTYPE_IMG, groupType, PREVIEW_TYPE } from '../../constants/app-constants';
import fileUtils from '../../utils/file-utils';
import notificationPreviewAction from '../../redux/action/notification-action';
import DateTimeUtils from '../../utils/datetime-utils';
import { formatDateTime } from '../../constants/app-constants';
import previewService from "../../services/preview-Service";

const { RangePicker } = DatePicker;

const defaultValue = {
    notificationImage: null,
    isOpenNewTab: false,
    keywordList: []
};


const AddEditNotificationDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [notificationImage, setBannerImage] = useState(defaultValue.notificationImage);
    const [keywordList, setKeywordList] = useState(defaultValue.keywordList);

    useEffect(() => {
        if (!isShow) {
            setBannerImage(defaultValue.notificationImage);
            setKeywordList(defaultValue.keywordList);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                title: editData.title,
                url: editData.url,
                status: editData.status,
                totalView: editData.totalView,
                enableNewTab: editData.enableNewTab,
				activeDate: [
					DateTimeUtils.parseDateToMoment(editData.startDate),
					DateTimeUtils.parseDateToMoment(editData.endDate),
				],
            });

            setBannerImage(editData.attachImage);
            setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            try {

                dispatch(appLoaderAction.enable());
                
                if (!editData) {
                    let bean = {
                        title: values.title,
                        keywordList: keywordList,
                        url: values.url,
                        attachImage: notificationImage,
                        enableNewTab: values.enableNewTab,
                        status: values.status,
                        totalView: 0,
                        startDate: values.activeDate[0].valueOf(),
						endDate: values.activeDate[1].valueOf(),
                    };
                    // console.log('add noti ', bean);
                    await notificationService.add({bean: bean});
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    bean.title = values.title;
                    bean.keywordList = keywordList;
                    bean.url = values.url;
                    bean.attachImage = notificationImage;
                    bean.enableNewTab = values.enableNewTab;
                    bean.status = values.status;
                    bean.totalView = editData.totalView;
                    bean.startDate = values.activeDate[0].valueOf();
                    bean.endDate = values.activeDate[1].valueOf();

                    // console.log('edit noti ', bean);
                    await notificationService.edit({bean: bean});
                }

                dispatch(appLoaderAction.disale());
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    };

    const onUploadTemp = ({ file }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setBannerImage(bean);
        }
	};

    const onPreview = async () => {
        const values = await form.validateFields();
		try {
			dispatch(appLoaderAction.enable());

            // const beanNotification = dispatch(notificationPreviewAction.addNotificationPreview({
			// 	...editData,
			// 	...values,
			// 	keywordList,
			// 	attachImage: notificationImage,
			// 	startDate: values.activeDate[0].valueOf(),
			// 	endDate: values.activeDate[1].valueOf(),
			// }));
            let previewBean = JSON.parse(JSON.stringify(editData));

            previewBean.title = values.title;
            previewBean.keywordList = keywordList;
            previewBean.url = values.url;
            previewBean.attachImage = notificationImage
            previewBean.enableNewTab = values.enableNewTab;
            previewBean.status = values.status;
            previewBean.totalView = editData.totalView;
            previewBean.startDate = values.activeDate[0].valueOf();
            previewBean.endDate = values.activeDate[1].valueOf();

            let previewList = [previewBean]

            const result = await previewService.savePreview({preview: { content: PREVIEW_TYPE.notification, listBean: previewList}});

			setTimeout(() => {
				dispatch(appLoaderAction.disale());
				window.open(
                    `${process.env.REACT_APP_PREVIEW_ENDPOINT}/?token=${result.token}`,
					'winname',
					'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no'
				);
			}, 500);
		} catch (err) {
			dispatch(appLoaderAction.disale());
            notifyUtitls.error(err);
		}
	}

    const disabledDate = (current) => {
        return current && current < DateTimeUtils.getCurrentDate();
      }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขการแจ้งเตือน' : 'เพิ่มการแจ้งเตือน'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />บันทึก
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            ยกเลิก
                        </Button>,
                        <Button className="mx-2 btn-line" onClick={() => onPreview()}>
                            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
                        </Button>
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_notification"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}
                        validateMessages={{
                            required: 'โปรดระบุ',
                        }}>

                        <Form.Item
                            label="ชื่อการแจ้งเตือน"
                            name="title"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="รูปภาพ"
                            valuePropName="fileList"
                            name="imageHeader"
                            rules={[
                                {
                                    required: notificationImage ? false : true,
                                },
                            ]}>
                            <UploadImage  
                                listType="picture-card"
                                accept={fileTYPE_IMG}
                                showUploadList={false}
                                onChange={onUploadTemp}
                                className={notificationImage ? 'view-upload' : null}>
                                  {notificationImage ? (
                                        <img
                                            src={
                                                notificationImage.tempFilename
                                                    ? fileUtils.getTempFileRenderUrl(
                                                            notificationImage.tempFilename,
                                                            notificationImage.type
                                                    )
                                                    : fileUtils.getFileRenderUrl(
                                                            groupType.NOTIFICATION,
                                                            editData ? editData.notificationId : null,
                                                            notificationImage.originalFilename
                                                    )
                                            }
                                            alt="avatar"
                                            style={{ width: '100%' }}
                                        />
                                    ) : 'อัปโหลดไฟล์'}
                            </UploadImage>
                            <label className="text-danger">* ขนาดรูปภาพที่แนะนำคือ 1900x710 pixels.</label>
                        </Form.Item>

                        <Form.Item label="ลิงค์" name="url">
                            <Input />
                        </Form.Item>

                        <Form.Item label="คีย์เวิร์ด" >
                            <EditableTagGroup onChange={setKeywordList} tags={keywordList} />
                        </Form.Item>

                        <Form.Item
                            label="วันที่แจ้งเตือน"
                            name="activeDate"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <RangePicker format={formatDateTime.DDMMYYYY_SLASH} allowClear={false} disabledDate={disabledDate}/>
                        </Form.Item>

                        <Form.Item label="เปิดแท็บใหม่" name="enableNewTab" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        <Form.Item label="สถานะ" name="status" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                    </Form>
                </Modal>
            </div>
        </div>
    )
};

export default AddEditNotificationDialog;